import React, { useEffect, useRef, useState } from "react";
import "./searchComponent.css";
import BackBtnSvg from "../../assets/ReactSvg/BackBtnSvg";
import AntdCustomInput from "../AntdCustomInput/Index";
import SearchSVGComponent from "../jsxsvg/SearchSVGComponent";
import CloseCircleBorderIcon from "../../assets/ReactSvg/CloseCircleBorderIcon";
import MicrophoneIconSvg from "../../assets/ReactSvg/MicrophoneIconSvg";
import SearchResultContainer from "./SearchResultContainer";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { useDispatch } from "react-redux";
import SearchLogoBgIconSvg from "../../assets/ReactSvg/SearchLogoBgIconSvg";
import searchBGMailLogo from "../../assets/searchBGMailLogo.svg"
import searchBGMailLogo1 from "../../assets/searchBGMailLogo1.svg"

const QUESTION_SUGGESTIONS = [
  { title: "Italian pizza", label: "For the pack of 13" },
  { title: "Spicy Biryani", label: "Hyderabadi style" },
  { title: "Authentic Chinese Dishes", label: "Chinese bowls, Sushi & more" },
];

const SearchComponent = () => {
  const dispatch = useDispatch();
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [isEnterPressed, setIsEnterPressed] = useState(false);
  const [dishSeachText, setDishSeachText] = useState("");
  const [apiResult, setApiResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const inputRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;
    setDishSeachText(value);
  };

  useEffect(() => {
    const handleResize = () => {
      // If viewport height shrinks significantly, keyboard is probably open
      const newHeight = window.innerHeight;
      if (viewportHeight - newHeight > 150) {
        setKeyboardOpen(true);
      } else {
        setKeyboardOpen(false);
      }
      setViewportHeight(newHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [viewportHeight]);

  const handleBackButtonClick = () => {
    if (isEnterPressed) {
      setIsEnterPressed(false);
      setDishSeachText("");
    } else {
      dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
    }
  };

  const fetchSearchResults = async () => {
    setLoading(true);
    try {
      setTimeout(() => {
        const dummyResponse = {
          header: "Search is in demo mode.",
          description:
            "We’re building a deep search that understands your taste. Soon, you’ll be able to find dishes or a customised list of dishes that perfectly match your preferences and what you’re searching for.",
          note: "You can also explore different options from our menu as below.",
          resultArray: [
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Veg%20aglio%20olio%20pasta.jpg",
              title: "Hyderabadi Chicken Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Cream%20of%20tomato%20soup.jpg",
              title: "Lucknowi (Awadhi) Chicken Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Ricotta%20cheese%20and%20spinach%20dumplings.jpg",
              title: "Hyderabadi Veg Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Veg%20club%20sandwich.jpg",
              title: "Paneer Makhni Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Mix%20veg%20flatbread.jpg",
              title: "Mushroom Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Masala%20omellete.jpg",
              title: "Prawn Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Malai%20paneer%20tikka.jpg",
              title: "Egg Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Chatpata%20paneer%20kathi%20roll.jpg",
              title: "Vegetable Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/tandoori%20roti.jpg",
              title: "Fish Biryani",
            },
            {
              img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/chicken%20manchow%20soup.jpg",
              title: "Mutton Biryani",
            },
          ],
        };
        setApiResult(dummyResponse);
        setLoading(false);
      }, 2000);
    } catch (err) {
      console.error("API error:", err);
    } finally {
    }
  };

  const handleSuggestClick = (question) => {
    setIsEnterPressed(true);
    setDishSeachText(question.title);
    fetchSearchResults(question.title);
  };

  const handleEnter = () => {
    if (inputRef.current?.input) {
      inputRef.current.input.blur();
    }

    setKeyboardOpen(false);
    setIsEnterPressed(true);
    fetchSearchResults(dishSeachText);
  };

  return (
    <div className="searchComponentWrapper">
      <div className="searchComponentTopWrapper">
        <button
          type="button"
          className="btn back-btn"
          style={{ height: 24, width: 24 }}
          onClick={handleBackButtonClick}
        >
          <BackBtnSvg />
        </button>
      </div>
      {!isEnterPressed ? (
        <div className="searchComponentMainWrapper">
          <div className="searchComponentTextLabel Satoshi">
            What’s on your mind today?
          </div>
          <img
            src={searchBGMailLogo1}
            alt="Search image"
            style={{ marginTop: "40px", padding: "0 23px" }}
          />
          {/* <SearchLogoBgIconSvg /> */}
        </div>
      ) : (
        <SearchResultContainer results={apiResult} loading={loading} />
      )}
      <div
        className="input-bar"
        style={{
          position: "fixed",
          bottom: keyboardOpen ? `${window.innerHeight - viewportHeight}px` : 0,
          left: 0,
          right: 0,
          padding: "12px 16px",
        }}
      >
        {!isEnterPressed && (
          <div className="searchSuggestionBoxWrapper">
            {QUESTION_SUGGESTIONS.map((item, index) => (
              <div
                key={index}
                className="searchSuggestionBox"
                onClick={() => handleSuggestClick(item)}
              >
                <div className="searchSuggestionBoxTitle Satoshi">
                  {item.title}
                </div>
                <div className="searchSuggestionBoxLabel Satoshi">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        )}
        <AntdCustomInput
          ref={inputRef}
          className="chefMainScreenSearchBar Satoshi searchMainScreenSearchBar"
          size="large"
          placeholder="What’s on your mind today?"
          onChange={handleChange}
          style={{ width: "100%" }}
          prefix={<SearchSVGComponent />}
          allowClear={{ clearIcon: <CloseCircleBorderIcon /> }}
          addonAfter={<span onClick={handleEnter} ><SearchSVGComponent /></span>}
          value={dishSeachText}
          onPressEnter={handleEnter}
        />
      </div>
    </div>
  );
};

export default SearchComponent;
